export const queryKeys = {
	auth: {
		all: ["auth"] as const,
		user: () => [...queryKeys.auth.all, "user"] as const,
	},
	districts: {
		all: ["districts"] as const,
		list: (params?: object) =>
			[...queryKeys.districts.all, "list", params ?? {}] as const,
		dashboard: (params: object) =>
			[...queryKeys.districts.all, "dashboard", params] as const,
		waterChart: (params: object) =>
			[...queryKeys.districts.all, "water", "chart", params] as const,
		waterTable: (params: object) =>
			[...queryKeys.districts.all, "water", "table", params] as const,
		waterMeterDetail: (sn: string) =>
			[...queryKeys.districts.all, "water", "meter", sn] as const,
		heatChart: (params: object) =>
			[...queryKeys.districts.all, "heat", "chart", params] as const,
		heatTable: (params: object) =>
			[...queryKeys.districts.all, "heat", "table", params] as const,
		heatMeterDetail: (sn: string) =>
			[...queryKeys.districts.all, "heat", "meter", sn] as const,
		alertLog: (params: object) =>
			[...queryKeys.districts.all, "alerts", params] as const,
		electricityChart: (params: object) =>
			[...queryKeys.districts.all, "electricity", "chart", params] as const,
		electricityTable: (params: object) =>
			[...queryKeys.districts.all, "electricity", "table", params] as const,
		electricityMeterDetail: (sn: string) =>
			[...queryKeys.districts.all, "electricity", "meter", sn] as const,
		meterKeys: (params?: object) =>
			[...queryKeys.districts.all, "meter-keys", params ?? {}] as const,
		apartments: (params: object) =>
			[...queryKeys.districts.all, "apartments", params] as const,
		apartment: (pk: number) =>
			[...queryKeys.districts.all, "apartments", pk] as const,
		mqttSources: (params: object) =>
			[...queryKeys.districts.all, "mqtt-sources", params] as const,
		readings: (params: object) =>
			[...queryKeys.districts.all, "readings", params] as const,
		readingDetail: (id: number) =>
			[...queryKeys.districts.all, "reading", id] as const,
		myProfile: () => [...queryKeys.districts.all, "my-profile"] as const,
	},
	reseller: {
		all: ["reseller"] as const,
		dashboard: (params: object) =>
			[...queryKeys.reseller.all, "dashboard", params] as const,
		managers: (params: object) =>
			[...queryKeys.reseller.all, "managers", params] as const,
		mqttSources: (params: object) =>
			[...queryKeys.reseller.all, "mqtt-sources", params] as const,
		mqttReadings: (districtId: number, params: object) =>
			[...queryKeys.reseller.all, "mqtt-readings", districtId, params] as const,
		mqttMeterReadings: (
			districtId: number,
			mqttReadingId: number,
			params: object,
		) =>
			[
				...queryKeys.reseller.all,
				"mqtt-meter-readings",
				districtId,
				mqttReadingId,
				params,
			] as const,
		detailMe: () => [...queryKeys.reseller.all, "me"] as const,
		manager: (id: number) =>
			[...queryKeys.reseller.all, "manager", id] as const,
		createdDistricts: (params: object) =>
			[...queryKeys.reseller.all, "created-districts", params] as const,
		myProfile: () => [...queryKeys.reseller.all, "profile"] as const,
		mqttSource: (sn: string) =>
			[...queryKeys.reseller.all, "mqtt-source", sn] as const,
		districtDetail: (id: number) =>
			[...queryKeys.reseller.all, "district", id] as const,
		readings: (params: object) =>
			[...queryKeys.reseller.all, "readings", params] as const,
		readingDetail: (id: number) =>
			[...queryKeys.reseller.all, "reading", id] as const,
	},
	resellerManager: {
		all: ["reseller-manager"] as const,
		dashboard: (params: object) =>
			[...queryKeys.resellerManager.all, "dashboard", params] as const,
		resellers: (params: object) =>
			[...queryKeys.resellerManager.all, "resellers", params] as const,
		reseller: (id: number) =>
			[...queryKeys.resellerManager.all, "reseller", id] as const,
		mySources: (params: object) =>
			[...queryKeys.resellerManager.all, "my-sources", params] as const,
		mqttReadings: (params: object) =>
			[...queryKeys.resellerManager.all, "mqtt-readings", params] as const,
		myProfile: () => [...queryKeys.resellerManager.all, "profile"] as const,
	},
	tenant: {
		all: ["tenant"] as const,
		apartments: () => [...queryKeys.tenant.all, "apartments"] as const,
		waterChart: (params: object) =>
			[...queryKeys.tenant.all, "water-chart", params] as const,
		heatChart: (params: object) =>
			[...queryKeys.tenant.all, "heat-chart", params] as const,
		electricityChart: (params: object) =>
			[...queryKeys.tenant.all, "electricity-chart", params] as const,
	},
	mediaTransmitters: {
		all: ["media-transmitters"] as const,
		list: (params: object) =>
			[...queryKeys.mediaTransmitters.all, "list", params] as const,
		detail: (sn: string) =>
			[...queryKeys.mediaTransmitters.all, "detail", sn] as const,
		detectedMeters: (sn: string, params: object) =>
			[...queryKeys.mediaTransmitters.all, "detected", sn, params] as const,
		report: (params: object) =>
			[...queryKeys.mediaTransmitters.all, "report", params] as const,
	},
} as const;
